import { normalizeFlow } from "./guideFlowCore";
import { autoLayoutGuideFlow } from "./guideFlowAutoLayout";

export const DEFAULT_GUIDE_FLOW_VIEWPORT_EXPORT = { x: 80, y: 40, zoom: 1 };

/** Strip optional ```json ... ``` wrapper from pasted text. */
export function stripJsonCodeFence(text) {
  let s = String(text || "").trim();
  if (!s) return s;
  const whole = /^```(?:json)?\s*\r?\n?([\s\S]*?)\r?\n?```\s*$/i;
  const mWhole = s.match(whole);
  if (mWhole) return mWhole[1].trim();
  const inner = /```(?:json)?\s*\r?\n?([\s\S]*?)\r?\n?```/i;
  const mInner = s.match(inner);
  if (mInner) return mInner[1].trim();
  return s;
}

/**
 * Serialize flow for export/import. Omits `edges` — they are rebuilt from `next_node_id` on question options and effect nodes.
 */
export function serializeGuideFlowForExport(flow) {
  const f = flow && typeof flow === "object" ? flow : {};
  const viewport = f.viewport && typeof f.viewport === "object" ? f.viewport : DEFAULT_GUIDE_FLOW_VIEWPORT_EXPORT;
  return JSON.stringify(
    {
      version: f.version || 1,
      viewport: {
        x: Number.isFinite(Number(viewport.x)) ? Number(viewport.x) : DEFAULT_GUIDE_FLOW_VIEWPORT_EXPORT.x,
        y: Number.isFinite(Number(viewport.y)) ? Number(viewport.y) : DEFAULT_GUIDE_FLOW_VIEWPORT_EXPORT.y,
        zoom: Number.isFinite(Number(viewport.zoom)) ? Number(viewport.zoom) : DEFAULT_GUIDE_FLOW_VIEWPORT_EXPORT.zoom,
      },
      start_node_id: f.start_node_id ?? null,
      nodes: Array.isArray(f.nodes) ? f.nodes : [],
    },
    null,
    2
  );
}

/**
 * Parse pasted/generated JSON into a normalized flow object (safe for GuideFlowBuilder `onChange`).
 * Always applies graph-based auto-layout unless `options.preservePositions === true` (AI/paste otherwise overlap).
 */
export function parseImportedGuideFlow(rawInput, fallbackQuestions = [], options = {}) {
  const text =
    typeof rawInput === "string" ? stripJsonCodeFence(rawInput.trim()) : JSON.stringify(rawInput ?? {});
  const obj = JSON.parse(text);
  const core = obj?.flow && typeof obj.flow === "object" ? obj.flow : obj;
  if (!core || !Array.isArray(core.nodes)) {
    throw new Error("Missing top-level `nodes` array (or `{ \"flow\": { \"nodes\": [...] } }`).");
  }
  let flow = normalizeFlow(core, fallbackQuestions);
  if (!options.preservePositions) {
    flow = autoLayoutGuideFlow(flow);
  }
  return flow;
}
